import React, { useEffect, useState } from 'react';
import MultiChoice from './MultiChoice';
import PlanningAssignmentService from '../../../../../Services/PlanningAssignmentService';
import ErrorMessage from '../../../../ErrorMessage';

export default function ServiceCountryMultiSelect(props) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!props.idFilter) {
      setOptions([]);
      return;
    }
    PlanningAssignmentService.GetServiceCountries(props.idFilter)
      .then((result) => {
        setOptions(result.map((country) => ({ label: country.name, value: country.countryId })));
      })
      .catch((ex) => {
        setOptions([]);
        ErrorMessage.SetErrorMessage('SCMS22', ex);
      });
  }, [props.idFilter]);

  return (
    <MultiChoice
      className='rmsc'
      options={options}
      selected={props.selected}
      onChange={props.onChange}
    />
  );
}
